import React from 'react';
import "./Styles/Calculators.css";
import "./Styles/ImportedStyles.css";
import NavBar from '../NavBar';
import UserProfileCalculatorHome from './Components/UserProfileRoute/UserProfileCalculatorHome';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import UserInfoProvider from './Components/Context/UserInfoContext';
import MedicalContextProvider from './Components/Context/MedicalContext';

function UserProfileCalculatorHomeRoute() {
    return (
        <UserInfoProvider>
            <MedicalContextProvider>
                <div className="UserProfileCalculatorHomeRoutePage">
                    <div className="UserProfileCalculatorHomeRouteNavBar">      
                        <NavBar/>
                    </div>
                    <div className="UserProfileCalculatorHomeRouteBlock">
                        <UserProfileCalculatorHome/>
                    </div>
                </div>
            </MedicalContextProvider>
       </UserInfoProvider>
    );
}

export default UserProfileCalculatorHomeRoute;